//dependencias
import React, { Component } from 'react';

//componentes
import InformeAdeC from './informeAdeC'

class Index extends Component {

    render(){
        return(
            <div>
                <InformeAdeC />
            </div>
        );
    }

}
export default Index;